module.exports = __webpack_public_path__ + "img/three.15aa35a4.png";